const firebaseConfig = {
    apiKey: "AIzaSyBZzjFG0qI9vvWUYNCJa4HlAbb0sZWerck",
    authDomain: "save-life-hospital.firebaseapp.com",
    projectId: "save-life-hospital",
    storageBucket: "save-life-hospital.appspot.com",
    messagingSenderId: "72860899740",
    appId: "1:72860899740:web:491c8b3b11ddbaaccdd059"
};

export default firebaseConfig;